import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const OutsourcingVsFull8 = props => (
    <section id="outsourcing-vs-full-section8" className="my pt-5 white-bg">
        <div className='blue-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5 blue">{props.t('services:outsourcingVsFull:section-8.title')}</h2>
            <p className='mb-5'>{props.t('services:outsourcingVsFull:section-8.txt')}</p>
            <div className="AccordionUI bg p-5 my-5">
                <div className='mb-5'>
                    <div className='d-flex align-items-center mb-4'>
                        <div className='arrow-container'>
                            <div className='arrow orange'>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                        <h3 className='h5 fw-600 m-0 orange'>{props.t('services:outsourcingVsFull:section-8.1.title')}</h3>
                    </div>
                    <p><Trans i18nKey='services:outsourcingVsFull:section-8.1.text' /></p>
                </div>
                <div className='mb-5'>
                    <div className='d-flex align-items-center mb-4'>
                        <div className='arrow-container'>
                            <div className='arrow orange'>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                        <h3 className='h5 fw-600 m-0 orange'>{props.t('services:outsourcingVsFull:section-8.2.title')}</h3>
                    </div>
                    <p><Trans i18nKey='services:outsourcingVsFull:section-8.2.text' /></p>
                </div>
                <div className='mb-5'>
                    <div className='d-flex align-items-center mb-4'>
                        <div className='arrow-container'>
                            <div className='arrow orange'>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                        <h3 className='h5 fw-600 m-0 orange'>{props.t('services:outsourcingVsFull:section-8.3.title')}</h3>
                    </div>
                    <p><Trans i18nKey='services:outsourcingVsFull:section-8.3.text' /></p>
                </div>
                <div>
                    <div className='d-flex align-items-center mb-4'>
                        <div className='arrow-container'>
                            <div className='arrow orange'>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                        <h3 className='h5 fw-600 m-0 orange'>{props.t('services:outsourcingVsFull:section-8.4.title')}</h3>
                    </div>
                    <p><Trans i18nKey='services:outsourcingVsFull:section-8.4.text' /></p>
                </div>
                <div>
                    <div className='d-flex align-items-center mb-4'>
                        <div className='arrow-container'>
                            <div className='arrow orange'>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                        <h3 className='h5 fw-600 m-0 orange'>{props.t('services:outsourcingVsFull:section-8.5.title')}</h3>
                    </div>
                    <p><Trans i18nKey='services:outsourcingVsFull:section-8.5.text' /></p>
                </div>
                <div>
                    <div className='d-flex align-items-center mb-4'>
                        <div className='arrow-container'>
                            <div className='arrow orange'>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                        <h3 className='h5 fw-600 m-0 orange'>{props.t('services:outsourcingVsFull:section-8.6.title')}</h3>
                    </div>
                    <p><Trans i18nKey='services:outsourcingVsFull:section-8.6.text' /></p>
                </div>
            </div>

            <p className='m-0'><Trans i18nKey="services:outsourcingVsFull:section-8.text" components={{ bold: <strong /> }} /></p>
        </Container>
    </section>
);

export default OutsourcingVsFull8;
